import React, { useCallback } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { invoicesPath, makeSearchPath } from '@/utils'
import { InvoiceNode } from '@/apollo/graphql'

interface IInvoiceRow {
  node: InvoiceNode
  onSelect: (node: InvoiceNode) => void
}

const InvoiceRow: React.FC<IInvoiceRow> = ({ node, onSelect }) => {
  const navigate = useNavigate()
  const { customerId } = useParams()

  const openDetail = useCallback(() => {
    navigate(
      makeSearchPath(invoicesPath, {
        customerId,
        id: node.id,
      }),
    )
  }, [node.id, customerId, navigate])

  return (
    <tr onClick={openDetail}>
      <td>{node.id}</td>
      <td>{node.dealIds}</td>
    </tr>
  )
}

export default InvoiceRow
